import { getDefaultStore } from "jotai";
import { makeUserSettings } from "../defaults";
import { userSettingsAtom } from "../atoms";
import { ApiClient } from "../../api/client";
import { UserSettings } from "../../../shared/types";
import { db } from "../../storage/storage";

export class UserStore {
  private _isDirty: boolean;
  private _settings: UserSettings;

  constructor() {
    this._isDirty = false;
    this._settings = makeUserSettings({});
  }

  async setFromServer(settings: UserSettings) {
    this._settings = settings;
    this._isDirty = false;
    await db.users.upsert({ id: "1", data: { settings: this._settings }, isDirty: 0 });
    getDefaultStore().set(userSettingsAtom, this._settings);
  }

  setFromCache({ userSettings, isDirty }: { userSettings: Partial<UserSettings>; isDirty: boolean }) {
    this._settings = makeUserSettings(userSettings);
    this._isDirty = isDirty;
    getDefaultStore().set(userSettingsAtom, this._settings);
  }

  async deleteAccount(): Promise<boolean> {
    const result = await ApiClient().users.delete();
    if (!result.deleted) {
      console.log("Unable to delete User");
      return false;
    }
    await db.drop();
    return true;
  }

  async persist(): Promise<boolean> {
    if (!this._isDirty) return true;
    let response;
    try {
      response = await ApiClient().users.updateSettings(this._settings);
    } catch (e) {
      console.log("Something went wrong");
      return false;
    }
    if (response.status) {
      this._isDirty = false;
      await db.users.upsert({ id: "1", data: { settings: this._settings }, isDirty: 0 });
    }
    return true;
  }

  async upsert(settings: UserSettings) {
    const newUserSettings = makeUserSettings({
      ...this._settings,
      ...settings,
    });
    this._settings = newUserSettings;
    this._isDirty = true;
    await db.users.upsert({ id: "1", data: { settings: newUserSettings }, isDirty: 1 });
    getDefaultStore().set(userSettingsAtom, newUserSettings);
  }
}
